module.exports = __webpack_public_path__ + "media/images/championship__iconChangeTeam-f9a196a91bee4bd9c4f45a01e5e72323.png";